<template>
  <md-dialog v-if="tripDetails" class="customer-login-form-dialog" :md-closed="closeDialog" :md-opened="openDialog" :md-close-on-esc="false"
             :md-click-outside-to-close="false"
             :md-active.sync="options.showCustomerLoginForm">
    <md-dialog-title  style="font-size: 2rem; border-bottom: 1px #E1E8F3 solid;">
      <div class="tab-header-grid">
        <div class="tab-title">
          {{options.Lang.Zugangsdaten_an_Kunden_schicken}}
        </div>
        <div class="tab-info-box">
          <SmallInfoBox title="Angebot" :content="tripDetails.data.attributes.alias" />
        </div>

        <div class="tab-info-box">
          <SmallInfoBox :title="'Nezasa ID'" :content="trip ? trip.nezasa_id : ''" :copy="true" />
        </div>
      </div>
      <section v-if="options.isUploading" class="loading_spinner">
        <div v-if="options.isUploading" class="ladebalken">
          <div class="custom-spinner"></div>
        </div>
      </section>
    </md-dialog-title>
    <md-dialog-content>
      <div class="ml-30">
        <br><br>
        <div style="display: flex;" class="" v-if="loaded">
          <div style="width: 50%;" class="form">
                <div class="pt-30">
              <md-field class="md-focused" >
                <label for="supplier">{{options.Lang.Sprache}}</label>
                <md-select tabindex="3" name="supplier" id="supplier" v-model="lang" @md-selected="getLang">
                  <md-option v-for="(language, index) in languages" :key="'index' + index" :value="language">{{ options.Lang.lang_code[language] }}</md-option>
                </md-select>
              </md-field>
            </div>
            <div class="pt-30">
              <md-field class="md-focused">
                <label for="email">{{options.Lang.Empfänger_Email}}<span class="md-required">*</span></label>
                <md-input tabindex="5" name="email" autocomplete="off" placeholder="Empfänger E-mail"
                          id="email"
                          v-model="customerEmail"
                          />
              </md-field>
            </div>
                <div class="pt-30">
                  <md-field class="md-focused">
                    <label for="cc_email">CC {{options.Lang.Empfänger_Email}}</label>
                    <md-input tabindex="4" name="cc_email" autocomplete="off" :placeholder="`CC ${options.Lang.Empfänger_Email}`"
                              id="cc_email"
                              v-model="senderCCEmail"/>
                  </md-field>
                </div>
            <div class="pt-30 ml-10">
              <SmallInfoBox
                  :title="`${options.Lang.lastCustomerLogin}:`"
                  :content="`${trip.lastLoginTime ? trip.lastLoginTime : options.Lang.niemals }`"
                  @getLock="resetCounter"
                  class="customer-info-box"
                  :actions="[{icon: require('@/assets/images/icons/lock.svg'), event:'getLock', title: options.Lang.Loginzähler_zurücksetzen}]"/>
              <SmallInfoBox
                  :title="`Logincode:`"
                  :content="`${loginCode != null ? loginCode : '---'}`"
                  @refreshCode="setLoginCode"
                  :actions="[{icon: require('@/assets/images/icons/refreshCode.svg'), event:'refreshCode', title: options.Lang.neuerCode}]"
                  class="customer-info-box"/>
              <div style="display: flex; align-items: center; gap: 8px; margin-bottom: 10px;">
                <SmallInfoBox
                    :title="`${options.Lang.Email_verschickt_am}:`"
                    :content="`${timestampMail != 'Invalid date' ? timestampMail : options.Lang.keine_Emails_gefunden}`"/>
                <span class="manual-send-btn" @click="markManualSend">
                  {{ options.Lang.manuell_gesendet || 'Sent manually' }}
                </span>
              </div>
            </div>
          </div>
          <TextEditorWithHeader :options="options" class="customer-email-editor" :editor="editor8" editorClass="emailBox" :label="`${options.Lang.editHelloLabel}<span style='color: red'>*</span>`" :model="this.email"/>
        </div>
      </div>
      <div v-if="showSendMailCheck" id="mailcheck" class="md-elevation-9">
        <p>
          {{options.Lang.verschickenAn}}<strong> {{ this.customerEmail }} </strong>{{ options.Lang.jetztVerschicken }}
        </p>
        <div>
          <md-button style="float: right;" class="md-raised md-primary" @click="sendMail"><strong>{{ options.Lang.Email_abschicken }}</strong></md-button>
          <md-button class="md-raised secondary" @click="closeCheck"><strong>{{ options.Lang.Abbrechen }}</strong></md-button>
        </div>
      </div>
      <Error class="errorDialog" v-if="options.showError && options.user.loggedIn" :options="options"></Error>
      <Success class="errorDialog" v-if="options.showSuccess && options.user.loggedIn" :options="options"></Success>
    </md-dialog-content>
    <md-dialog-actions class="tab-actions-border">
      <md-button  class="md-raised md-primary customer-pdf-upload-button" @click="sendMail"><strong>{{ options.Lang.Email_abschicken }}</strong></md-button>
      <md-button tabindex="8" class="md-raised secondary " @click="closeDialog"><strong>{{options.Lang.Fenster_schließen}}</strong></md-button>
    </md-dialog-actions>
  </md-dialog>
</template>

<script>
import * as moment from 'moment'
import {validationMixin} from 'vuelidate'
import {Editor, EditorContent} from '@tiptap/vue-2'
import Underline from '@tiptap/extension-underline'
import StarterKit from '@tiptap/starter-kit'
import Link from "@tiptap/extension-link";
import Success from "@/components/dialogs/Success";
import stringMixin from '@/mixins/stringMixin'
import SmallInfoBox from '@/components/parts/SmallInfoBox.vue'
import TextEditorWithHeader from '../parts/TextEditorWithHeader.vue';
import Error from './Error.vue'

export default {
  name: 'formFirstImage',
  mixins: [validationMixin, stringMixin],
  components: {
    TextEditorWithHeader,
    Error,
    EditorContent,
    Success,
    SmallInfoBox
  },
  props: {
    options: {
      type: Object,
      required: true
    },
    currentTrip: {
      type: Object
    },
  },
  data: () => ({
    brands: [],
    openDialog: true,
    betreffDe: null,
    betreffEn: null,
    showSendMailCheck: false,
    loaded: false,
    senderCCEmail: null,
    languages: [],
    loginCode: null,
    trip: null,
    sending: false,
    signature: null,
    reply: null,
    company: null,
    logo: null,
    tripAlias: null,
    emailDefault: null,
    emailEnglisch: null,
    timestampMail: null,
    tripDetails: null,
    email: null,
    lang: "de",
    customerEmail: null,
    birthday: null,
    customerName: null,
    from: process.env.MAIL_CUSTOMER_NAME,
    tripUrl: process.env.VUE_APP_CLIENT_URL,
    editor8: new Editor({
      content: '',
      extensions: [
        StarterKit,
        Underline,
        Link.configure({ openOnClick: true }),
      ],
    }),
  }),
  created () {

  },
  async mounted () {
    this.trip = this.currentTrip;
    this.tripDetails = await this.loadJsonField('trip_details');
    this.tripAlias = this.tripDetails.data.attributes.alias;
    this.customerEmail = this.tripDetails.data?.attributes?.pax?.contact?.email
    this.senderCCEmail = this.options.user.username;
    this.getUserToTrip(this.tripDetails.data.id)
    this.getModules();
    this.getTimestamp();
    this.getLoginCode();
  },
  watch: {},
  methods: {
    async loadJsonField (key) {
      const trip = this.currentTrip ? this.currentTrip : null;
      const jsonPath = trip.json_path;

      const payload = {
        data: {
          file_path: jsonPath,
          key: key
        }
      };

      let self = this;

      return new Promise(resolve => {
        this.doPost(payload, 'json/findFieldInJsonFile', function (res) {
          if (res.data.status === 'error') {
            self.help.log(self.$t(res.msg), false, true);
            return resolve(null);
          }
          resolve(res.data.value);   // return extracted JSON field
        });
      });
    },
    sanitizeForOutlook (html) {
      if (!html) return '';

      // remove outer document wrappers if present
      html = html
          .replace(/<!DOCTYPE[\s\S]*?>/gi, '')
          .replace(/<\/?html[^>]*>/gi, '')
          .replace(/<\/?head[^>]*>[\s\S]*?<\/head>/gi, '')
          .replace(/<\/?body[^>]*>/gi, '');

      // normalize newlines -> <br>
      html = html.replace(/\r\n|\r|\n/g, '<br>');

      // turn empty <p> into non-breaking spacer paragraphs Outlook will keep
      html = html.replace(/<p>\s*<\/p>/gi, '<p style="margin:0 0 12px 0;">&nbsp;</p>');

      return html.trim();
    },
    async getUserToTrip (id) {
      let self = this;
      await self.doPost({ data: id }, 'getUserToTrip', function (res) {
        if (res.data.status === 'error') {
          self.help.log(self.$t(res.msg), false, true);
        } else {
          self.reisedesigner = res.data.data[0];
        }
      });
    },
    sendMailCheck () {
      this.showSendMailCheck = true;
    },
    closeCheck () {
      this.showSendMailCheck = false;
    },
    async getLoginCode () {

      let self = this;
      self.loaded = false;
      self.loginCode = null;
      self.editor8.commands.setContent("self.email");
      await this.doPost({ data: this.tripDetails.data.id }, 'getLoginCode', function (res) {
        if (res.data.status === 'error') {
          self.help.log(self.$t(res.msg), false, true);
        } else {
          let result = res.data.data[0];
          self.loginCode = result.loginCode;
          if (self.loginCode == null || self.loginCode.length === 0) {
            self.setLoginCode()
          } else {
            self.getDbMails()
            self.loaded = true;
          }
        }
      });
    },
    async setLoginCode () {
      let self = this;
      await this.doPost({ data: this.tripDetails.data.id }, 'setLoginCode', function (res) {
        if (res.data.status === 'error') {
          self.help.log(self.$t(res.msg), false, true);
        } else {
          //
        }
      });
      await this.getLoginCode();
      this.loaded = true;
    },
    async getModules () {
      let self = this;
      self.brands = []
      self.doPost({}, 'getAllBranding', function (res) {
        if (res.data.status === 'error') {
          self.help.log(self.$t(res.msg), false, true);
        } else {
          let result = res.data.data;
          for (let i = 0; i < result.length; i++) {
            self.brands.push(result[i])

          }
          self.getBrandName();
        }
      });

    },
    getBrandName () {
      let test = this.trip.Branding
      this.brands.forEach(brand => {
        if (brand.adresse === test) {
          this.trip.Branding = brand.id
        }
      })
      this.getGlobalInfo();
    },
    async getGlobalInfo () {
      let self = this;
      let mydata = {
        id: this.trip.Branding
      }
      await this.doPost({ data: mydata }, 'getSingleBranding', function (res) {
        if (res.data.status === 'error') {
          self.help.log(self.$t(res.msg), false, true);
        } else {
          let result = res.data.data[0];
          self.brandingLang = res.data.data
          let default_lang = res.data.data[0].sprache
          const match = res.data.data.find(entry => entry.lang_code === default_lang);
          if (match) {
            result = match;
          }
          let tempArray = [];
          res.data.data.forEach(element => {
            tempArray.push(element.lang_code)
          })
          self.lang = default_lang;
          self.languages = tempArray;
          self.signature = result.signature;
          self.logo = result.baseLogo
          self.company = result.bezeichnung;
          self.reply = result.replyzugang;
          self.betreffDe = result.emailBetreffCustomer;
          self.betreffEn = result.emailBetreffCustomer;
          self.emailDefault = result.emailCustomer;
          self.letsgo = true;
        }
      });
      await self.getDbMails();
    },
    async getDbMails () {
      let self = this;
      let mydata = {
        id: self.trip.Branding
      }
      await this.doPost({ data: mydata }, 'getdbmails', function (res) {
        if (res.data.status === 'error') {
          self.help.log(self.$t(res.msg), false, true);
        } else {
          let dbmails = res?.data?.data || [];
          if (dbmails.length > 0) {
            self.emailEnglisch = dbmails[0].emailCustomer_en || '';
          }

          self.getEmail();
        }
      });
    },
    moment (date) {
      return moment(date)
    },
    parseDate (date) {
      //let s = "2024-01-08T22:20:00.000+08:00";
      return moment(date).format('DD. MMM HH:mm');
    },
    getTimestamp () {
      let nezasaId = this.tripDetails.data.id;
      let self = this;
      this.doPost({ data: nezasaId }, 'getTimestampMail', function (res) {
        if (res.data.status === 'error') {
          self.help.log(self.$t(res.msg), false, true);
        } else {
          let result = res.data.data
          self.timestampMail = self.parseDate(result[0].timestampCustomerMail)
          //alert(self.timestampMail)
        }
      });
    },
    setTimestamp () {
      //alert("asd")
      let data = {
        nezasaId: this.tripDetails.data.id,
        time: moment()
      }
      let self = this;
      this.doPost({ data: data }, 'setTimestampMail', function (res) {
        if (res.data.status === 'error') {
          self.help.log(self.$t(res.msg), false, true);
        } else {
          //console.log(result, "timestamp")          
        }
      });
    },
    markManualSend () {
      let self = this;
      self.setTimestamp();
      self.timestampMail = self.parseDate(moment());
      self.options.showSuccess = true;
    },
    resetCounter () {
      let nezasaId = this.tripDetails.data.id;
      let self = this;
      this.doPost({ data: nezasaId }, 'resetLoginCounter', function (res) {
        if (res.data.status === 'error') {
          self.help.log(self.$t(res.msg), false, true);
        } else {
          self.options.showSuccess = true;
          if (self.trip) {
            self.trip.lastLoginTime = null; // or set to a new value as appropriate
          }

          // Optional: re-fetch server-side value if needed
          // self.getTimestamp();

          // Ensure Vue updates the view
          self.$nextTick(() => self.$forceUpdate());
        }
      });
    },
    getLang () {
      //alert(this.lang)
      this.getEmail()
    },
    getEmail () {
      const self = this;

      // if we are not in the middle of sending, clear current email
      if (!self.sending) {
        self.email = '';
      }

      // safety: brandingLang might not be loaded yet
      if (!Array.isArray(self.brandingLang) || self.brandingLang.length === 0) {
        if (!self.email) {
          self.email = '';
          self.editor8.commands.setContent(self.email);
        }
        return;
      }

      const match = self.brandingLang.find(entry => entry.lang_code === self.lang) || {};

      self.emailDefault = match.emailCustomer || '';
      self.betreffDe = match.emailBetreffCustomer || '';
      self.betreffEn = match.emailBetreffCustomer || '';

      // Always replace: variables without data become empty instead of staying "[...]".
      const options = {
        lang_code: self.lang,
        LangFile: self.options.Lang,
        // salutation: per-branding [title] override of the selected language
        globalinfo: { signature: self.signature, salutation: match.salutation || null },
        reisedesigner: self.reisedesigner,
        tripUrl: self.tripUrl,
        loginCode: self.loginCode,
        general: self.options
      };

      self.emailDefault = self.replaceTemplatePlaceholders(self.emailDefault, self.tripDetails, options);

      self.email = self.emailDefault;
      self.editor8.commands.setContent(self.email);
    },
    sendMail () {
      const self = this;
      self.sending = true;
      self.options.isUploading = true;

      let emailContent = self.editor8.getHTML();
      emailContent = self.sanitizeForOutlook(emailContent);

      const html = `
              <!DOCTYPE html>
              <html>
                <head>
                  <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
                  <meta name="viewport" content="width=device-width, initial-scale=1.0"/>
                </head>
                <body style="margin:0; padding:0; background-color:#ffffff;">
                  <center>
                    <table width="650" border="0" cellpadding="0" cellspacing="0"
                      style="border-collapse:collapse; font-family:Arial, sans-serif; font-size:14px; line-height:20px; color:#000;">
                      <tr>
                        <td style="padding:20px; text-align:left;">
                          ${emailContent}
                        </td>
                      </tr>
                    </table>
                  </center>
                </body>
              </html>
              `;

      self.setTimestamp();

      const form = {
        context: 'sendToCustomer',
        // Backend picks the branding's own From/Reply-To (brandings.sender_*) from this id.
        branding_id: self.trip && self.trip.Branding ? self.trip.Branding : null,
        client_name: null,
        emailto: self.customerEmail,
        email: html,
        supplier_name: '...',
        cc_email: self.senderCCEmail ? self.senderCCEmail : null,
        reply_email: self?.options?.user?.username ? self.options.user.username : self.reply,
        sender_name: 'Karsten Spieß',
        supplier_gender: null,
        company: self.company,
        logo: self.logo,
        from: self?.options?.user?.username ? self.options.user.username : self.from
      };

      // gender + salutation construction (kept in case you need it later)
      let gender = null;
      let conString = '';
      const contact = self?.tripDetails?.data?.attributes?.pax?.contact;
      const paxInfo0 = self?.tripDetails?.data?.attributes?.pax?.paxInfo?.[0];

      if (contact && contact.lastName) {
        gender = contact.gender;
        const firstname = contact.lastName.slice(0, 1).toUpperCase() + contact.lastName.slice(1).toLowerCase();
        conString += firstname;
      } else if (paxInfo0 && paxInfo0.lastName) {
        gender = paxInfo0.gender;
        const firstname = paxInfo0.lastName.slice(0, 1).toUpperCase() + paxInfo0.lastName.slice(1).toLowerCase();
        conString += firstname;
      }

      // subject from branding, with placeholder replacement
      form.subject = self.lang === 'de'
        ? (self.betreffDe || 'Ihre Zugangsdaten')
        : (self.betreffEn || 'Your login information');

      // salutation: per-branding [title] override of the selected language
      const langMatch = (Array.isArray(self.brandingLang) ? self.brandingLang : [])
        .find(entry => entry.lang_code === self.lang) || {};
      const options = {
        lang_code: self.lang,
        LangFile: self.options.Lang,
        globalinfo: { signature: self.signature, salutation: langMatch.salutation || null },
        reisedesigner: self.reisedesigner,
        tripUrl: self.tripUrl,
        loginCode: self.loginCode,
        general: self.options
      };

      form.subject = self.replaceTemplatePlaceholders(form.subject, self.tripDetails, options);
      form.subject = form.subject.replace(/<\/?[^>]+>/ig, ' ');

      self.doPost({
        userdata: self.options.user,
        data: form
      }, 'sendTripToSupplier', function (res) {
        if (res.data.status === 'error') {
          self.help.log(self.$t(res.msg), false, true);
        } else {
          self.options.showSuccess = true;
          self.closeDialog();
        }
      }).finally(() => {
        self.options.isUploading = false;
        self.sending = false;
      });
    },
    closeDialog () {
      this.returnToBrandName();
      this.options.showCustomerLoginForm = false;
      this.options.currentTrip = null;
    },
    returnToBrandName () {
      let test = this.trip.Branding
      this.brands.forEach(brand => {
        if (brand.id === test) {
          this.trip.Branding = brand.adresse
        }
      })
      this.brands.forEach(brand => {
        if (brand.id === this.options.currentTrip.Branding) {
          this.options.currentTrip.Branding = brand.adresse
        }
      })
    },
    refreshDialog () {
      let self = this;
      self.options.showCustomerLoginForm = false;
      self.$nextTick(() => {
        self.options.showCustomerLoginForm = true;
      });
    }
  }
}
</script>

<style lang="scss">
@use '../../assets/style/General/tab_layout.scss';
.emailBox {
  text-align: left;
}
#mailcheck{
  position: absolute;
  height: 15rem;
  width: 60%;
  left: 20%;
  top: 10rem;
  background-color: white;
  padding: 2rem;
}
#mailcheck p {
 height: 60%;
}

.imgRemove{
  margin-top: 5px;
  background-color: rgb(253, 217, 223);
  text-align: center;
}
.imgRemove:hover{
  cursor: pointer;
}
.imgchoice{
  min-height: 100px;
  min-width: 150px;
  max-width: 150px;
  max-height: 100px;
}
.dialog{
  width: 100%;
}
.imgContainer{
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.8);
  z-index: 9999;
}

.imgContainer img:hover{
  cursor: pointer;
}
.showMail{
  position: absolute;
  min-width: 900px;
  max-width: 900px;
  margin-left: auto;
  margin-right: auto;
  height: 100%;
  background: white;
  padding: 50px;
  overflow-y: auto;
}
.tableclass{
  width: 100%;
  min-height: 70px;
  padding: 5px 5px;
  vertical-align: bottom;
  border-collapse: collapse;
}

.tableclass:hover{
  cursor: pointer;
}
.tableclass2{
  width: 100%;
  min-height: 30px;
  padding: 5px 5px;
  vertical-align: bottom;
  border-collapse: collapse;

}
.tableclass td{
  padding: 5px;
  vertical-align: top;
}

.tableclass2 td{
  padding: 5px;
  vertical-align: top;
}

.tableclass tr{
  padding: 5px;
  background-color: rgb(243, 243, 243);
}
.spacer{
  background-color: white;
  height: 5px;
}
.name{
  width: 10%;
}

.date{
  width: 10%;
}

.trip-details{
  width: 30%;
}

.address1{
  width: 15%;
}

.address2{
  width: 20%;
}

.cc{
  width: 15%;
}
.minH{
  min-height: 50px;
}

.none{
  display: none;
}
.formTD {
  background-color: rgb(249, 249, 249);
  margin-bottom: 5px;
}

.catTR td{
  background-color: white;
}

.blubbiblubbi.hai .ProseMirror{
  min-height: 26rem !important;
  max-height: 26rem !important;
  min-width: 45rem !important;
  max-width: 45rem !important;
}
.customer-login-form-dialog .md-dialog-container{
  max-width: 1500px !important;
  width: 1500px !important;
  margin: 0 auto;
  border-radius: 12px;
}
.customer-pdf-upload-button{
  float: inline-end;
}
.customer-info-box{
  width: fit-content;
  margin-bottom: 10px;
}
.customer-email-editor{
  margin-left: 20px;
  margin-bottom: 20px;
}

.manual-send-btn {
  display: flex;
  align-items: center;
  background: #ff5252;
  border-radius: 13px;
  padding: 10px 18px;
  height: 40px;
  white-space: nowrap;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  color: #fff;
  box-sizing: border-box;
}
.manual-send-btn:hover {
  background: #e53935;
}

</style>